import Vue from 'vue';
// eslint-disable-next-line import/no-unresolved
import Plyr from 'plyr';

Vue.component('video-player-header', {
    data() {
        return {
            video: null,
            videoPlaying: false,
            videoPause: false,
        };
    },

    mounted() {
        Vue.nextTick(() => {
            Vue.nextTick(this.setupVideo);
        });
    },

    watch: {
    },

    methods: {
        playVideo() {
            this.video.play();
            this.videoPlaying = true;
        },

        stopVideo() {
            this.video.pause();
        },

        /**
        * Play the intro video
        */
        setupVideo() {
            this.video = new Plyr(this.$refs.video, {
                muted: true,
                settings: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
            });

            if (!this.video) {
                return;
            }

            this.video.on('play', (event) => {
                this.videoPlaying = true;
                this.videoPause = false;
            });

            this.video.on('pause', (event) => {
                this.videoPlaying = false;
                this.videoPause = true;
            });

            this.video.on('seeking', (event) => {
                this.videoPlaying = true;
            });

            this.video.on('ended', (event) => {
                this.videoPlaying = false;
                this.videoPause = false;
            });
        },
    },
});
